const countries = {
  AT: 'common.countries.austria',
  BE: 'common.countries.belgium',
  CA: 'common.countries.canada',
  CH: 'common.countries.switzerland',
  CO: 'common.countries.colombia',
  CZ: 'common.countries.czech_republic',
  DE: 'common.countries.germany',
  DK: 'common.countries.denmark',
  ES: 'common.countries.spain',
  FR: 'common.countries.france',
  GB: 'common.countries.uk',
  GR: 'common.countries.greece',
  ID: 'common.countries.indonesia',
  IE: 'common.countries.ireland',
  IL: 'common.countries.israel',
  IN: 'common.countries.india',
  IT: 'common.countries.italy',
  KR: 'common.countries.korea',
  NL: 'common.countries.netherlands',
  NO: 'common.countries.norway',
  NZ: 'common.countries.new_zealand',
  PE: 'common.countries.peru',
  PH: 'common.countries.philippines',
  PL: 'common.countries.poland',
  PR: 'common.countries.puerto_rico',
  PT: 'common.countries.portugal',
  RU: 'common.countries.russia',
  SE: 'common.countries.sweden',
  SK: 'common.countries.slovakia',
  UA: 'common.countries.ukraine',
  US: 'common.countries.usa',
  ZA: 'common.countries.south_africa',
};

export default countries;
